import {useEffect, useState} from "react";
import {STORAGE_KEY} from "../constant/StorageConstant";

const useLocalStorage = (key, initialValue) => {
  const [data, setData] = useState(initialValue);
  useEffect(() => {
    const getData = window.localStorage.getItem(key);

    if (getData) {
      if (isStringValue(key)) {
        setData(getData);
      } else {
        setData(JSON.parse(getData));
      }
    } else {
      storeData(initialValue);
      setData(initialValue);
    }
  }, [key]);

  const storeData = updateValue => {
    setData(updateValue);
    if (!updateValue) {
      window.localStorage.removeItem(key);
      return;
    }
    if (isStringValue(key)) {
      window.localStorage.setItem(key, updateValue);
    } else {
      window.localStorage.setItem(key, JSON.stringify(updateValue));
    }
  };

  const isStringValue = (key) => {
    return key === STORAGE_KEY.TOKEN;
  }

  return {
    data,
    storeData,
  };
};

export default useLocalStorage;